import React, { useState, useMemo } from "react";
import { FormControl, InputLabel, Select, MenuItem, Grid, Typography, TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { TemplateTypes } from "../../config";



const SearchableTemplateDropdown = ({ value, onChange, templatesList = [], isDisabled = false, error, helperText, onBlur, validate }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [open, setOpen] = useState(false);

    const filteredTemplates = useMemo(() => {
        if (!searchTerm) return templatesList.filter(t => t.status === "approved");

        return templatesList
            .filter(t => t.status === "approved")
            .filter(template => template.templateName?.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [templatesList, searchTerm]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSearchTerm("");
    };

    return (
        <FormControl fullWidth>
            <InputLabel id="select-template-label">Select Template</InputLabel>
            <Select
                fullWidth
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                labelId="select-template-label"
                id="select-template-label"
                value={value ?? ""}
                onChange={onChange}
                disabled={isDisabled}
                error={Boolean(error)}
                onBlur={onBlur}
                label="Select Template"
                MenuProps={{
                    PaperProps: {
                        sx: {
                            overflow: "scroll",
                            maxHeight: "40%",
                            boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                            alignItems: filteredTemplates.length > 0 ? "unset" : "center",
                            justifyContent: filteredTemplates.length > 0 ? "unset" : "center",
                        },
                    },
                }}
            >

                {/* Search Input */}
                <Box sx={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
                    <TextField
                        size="small"
                        placeholder="Search templates"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        onClick={e => e.stopPropagation()}
                        onKeyDown={e => e.stopPropagation()}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                    />
                </Box>

                {filteredTemplates.length > 0 ? (
                    filteredTemplates.map((template, index) => (
                        <MenuItem key={index} value={template}>
                            <Grid container justifyContent={"space-between"} sx={{ pt: "2px" }}>
                                <Grid item md={7}>
                                    <Typography variant="h6">{template.templateName}</Typography>
                                </Grid>
                                <Grid item md={4} sx={{ display: "flex", flexDirection: "column" }}>
                                    <Typography variant="body1">
                                        Type:{" "}
                                        {(() => {
                                            const type = template.templateType;

                                            switch (type) {
                                                case TemplateTypes.TEXT_MESSAGE:
                                                    return <b>Text Message</b>;
                                                case TemplateTypes.RICH_CARD:
                                                    return <b>Rich Card Stand-alone</b>;
                                                case TemplateTypes.CAROUSEL:
                                                    return <b>Rich Card Carousel</b>;
                                                case TemplateTypes.TEXT_MESSAGE_WITH_MEDIA:
                                                    return <b>Text + PDF</b>;
                                                default:
                                                    return type;
                                            }
                                        })()}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem disabled>
                        <Typography variant="h5">No templates found</Typography>
                    </MenuItem>
                )}
            </Select>
            {helperText && (
                <Typography color="error" variant="caption">
                    {helperText}
                </Typography>
            )}
        </FormControl>
    );
};

export default SearchableTemplateDropdown;
